import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VRow,{staticClass:"wizard__content--item-wrapper"},[_c(VCol,{staticClass:"wizard__content--item-content",attrs:{"md":"8"}},[_vm._t("input"),(_vm.$vuetify.breakpoint.smAndDown)?_vm._t("info"):_vm._e()],2),(_vm.$vuetify.breakpoint.mdAndUp)?_c(VCol,{staticClass:"wizard__content--item-info",attrs:{"md":"4"}},[_vm._t("info")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }